import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from "@components/mantine";
import { useMemo } from "react";
import { Locales } from "../../../strings/Locales.js";
import { usePrivilegeRow } from "../PrivilegeTableContext.js";
import { PrivilegesTableUtils } from "../PrivilegesTableUtils.js";
var defaultOptions = {
    disabled: {
        value: "VIEW",
        label: Locales.format("AccessLevelPicker.option.VIEW")
    },
    enabled: {
        value: "EDIT",
        label: Locales.format("AccessLevelPicker.option.EDIT")
    }
};
export var GranularAccessLevelPicker = function(param) {
    var owner = param.owner, targetDomain = param.targetDomain, targetId = param.targetId, _options = param.options, options = _options === void 0 ? defaultOptions : _options;
    var id = PrivilegesTableUtils.getRowId({
        owner: owner,
        targetDomain: targetDomain,
        targetId: targetId
    });
    var ref = usePrivilegeRow(id), onChange = ref.onChange, selectedPrivileges = ref.selectedPrivileges, readOnly = ref.readOnly;
    var data = useMemo(function() {
        return [
            options.disabled,
            options.enabled
        ];
    }, [
        options
    ]);
    var value = selectedPrivileges.some(function(privilege) {
        return privilege.targetId === targetId;
    }) ? options.enabled.value : options.disabled.value;
    return /*#__PURE__*/ _jsx(Select, {
        data: data,
        value: value,
        w: 148,
        readOnly: readOnly,
        onChange: function(newValue) {
            if (newValue === options.disabled.value) {
                onChange(selectedPrivileges.filter(function(privilege) {
                    return privilege.targetId !== targetId;
                }));
            } else {
                // special case for 'ALLOW' privilege the type should not exist as the backend expects it
                var privilege = options.enabled.value === "ALLOW" ? {
                    targetId: targetId,
                    owner: owner,
                    targetDomain: targetDomain
                } : {
                    type: options.enabled.value,
                    targetId: targetId,
                    owner: owner,
                    targetDomain: targetDomain
                };
                onChange(_to_consumable_array(selectedPrivileges).concat([
                    privilege
                ]));
            }
        }
    });
};

//# sourceMappingURL=GranularAccessLevelPicker.js.map